import React, { useRef } from "react";
import "../Shopidy/CategoryView.css";
import Slider from "react-slick";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const GroupSlider = ({ categories }) => {
  const sliderRef = useRef(null);
  const itemLength = categories?.length || 0;
  const isInfinite = itemLength > 6;

  const next = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };
  const previous = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: isInfinite,
    speed: 500,
    slidesToShow: Math.min(6, itemLength || 1),
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(5, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(4, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(3, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 3,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: Math.min(2, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 2,
        },
      },
    ],
  };

  if (!categories || categories.length === 0) {
    return <div className="text-muted py-2">No categories in this group</div>;
  }

  return (
    <div className="slider-container" style={{ position: "relative" }}>
      <Slider ref={sliderRef} {...settings}>
        {categories.map((cat, index) => {
          const imgSrc =
            cat.image__image ||
            cat.image?.image ||
            cat.image ||
            cat.image_url;
          return (
            <div className="px-1" key={cat.id || index}>
              <div className="cat-item">
                <div className="cat-img">
                  {imgSrc ? (
                    <img
                      src={imgSrc}
                      className="mx-auto image-fluid"
                      alt={cat.name || "Category"}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100 fw-bold text-secondary">
                      {(cat.name || "C").charAt(0)}
                    </div>
                  )}
                </div>
                <div className="cat-title">
                  <p>{cat.name}</p>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
      {itemLength > 6 && (
        <>
          <div
            className="slick-arrow"
            style={{ left: "-15px", top: "25%", background: "#fff", cursor: "pointer" }}
            onClick={previous}
          >
            <MdChevronLeft size={30} />
          </div>
          <div
            className="slick-arrow"
            style={{ right: "-15px", left: "auto", top: "25%", background: "#fff", cursor: "pointer" }}
            onClick={next}
          >
            <MdChevronRight size={30} />
          </div>
        </>
      )}
    </div>
  );
};

const CategoryGroupingView = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="categories-container container">
        <div className="text-center py-4 text-muted">No category groupings configured</div>
      </div>
    );
  }

  return (
    <div className="categories-container container">
      {data.map((group, groupIdx) => {
        const categories = group.categories || group.category || [];
        return (
          <div key={group.id || groupIdx} className="category-grouping-block mb-4">
            {group.title && (
              <div className="d-flex align-items-baseline gap-2 mb-2">
                <h4 style={{ fontWeight: 700, fontSize: "1.25rem", color: "#212529", margin: 0 }}>
                  {group.title}
                </h4>
                {group.description && (
                  <span className="text-muted" style={{ fontSize: "0.875rem" }}>
                    - {group.description}
                  </span>
                )}
              </div>
            )}
            <GroupSlider categories={categories} />
          </div>
        );
      })}
    </div>
  );
};

export { CategoryGroupingView };
